<template>
  <section class="content">
    <BlockUI v-show="loadingShow">
      <div class="spinner-border text-info"></div>
      <p>شکیبا باشید...</p>
    </BlockUI>
    <div class="body_scroll">
      <div class="block-header">
        <div class="row">
          <div class="col-lg-7 col-md-6 col-sm-12">
            <h2>داشبورد مدیریتی</h2>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#" @click="$store.state.contentPane='Dashboard'">
                  <i class="zmdi zmdi-home"></i>پنل مدیریت
                </a>
              </li>

              <li class="breadcrumb-item active">
                <a href="#">داشبورد مدیریتی</a>
              </li>
            </ul>
            <button class="btn btn-primary btn-icon mobile_menu" type="button">
              <i class="zmdi zmdi-sort-amount-desc"></i>
            </button>
          </div>
          <div class="col-lg-5 col-md-6 col-sm-12">
            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button">
              <i class="zmdi zmdi-arrow-right align-middle"></i>
            </button>
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="خروجی اکسل"
                            data-color="red"
                            data-toggle="modal"
                            @click="openReportModal()">

                          گزارش گیری
                        </button>-->
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="فاکتور جدید"
                            data-color="red"
                            data-toggle="modal"
                            @click="openNewFactorModal()">
                          فاکتور جدید
                        </button>-->
            <!--            <button
                            class="btn btn-primary float-right right_icon_toggle_btn"
                            type="button"
                            title="گزارش راهکاران"
                            data-color="red"
                            data-toggle="modal"
                            @click="openRehkaranReportModal()">
                          گزارش راهکاران
                        </button>-->
            <button
                class="btn btn-primary float-right right_icon_toggle_btn"
                type="button"
                title="گزارش جدید"
                data-color="red"
                data-toggle="modal"
                @click="openMakeReportModal()">
              گزارش جدید
            </button>
            <button
                class="btn btn-primary float-right right_icon_toggle_btn"
                type="button"
                title="ثبت سند حسابداری"
                data-color="red"
                data-toggle="modal"
                @click="postSanad">
              ثبت سند حسابداری
            </button>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row clearfix">
          <div class="col-lg-12">
            <div class="card">
              <div class="row">
                <div class="col-lg-12">
                  <select v-model="pageSize">
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <div class="body">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped table-hover dataTable js-exportable">
                    <thead>
                    <tr>
                      <th class="text-center">فاکتور</th>
                      <th class="text-center">شماره‌فاکتور</th>
                      <th class="text-center">فروشگاه</th>
                      <th class="text-center">فروشنده</th>
                      <th class="text-center">کالاها</th>
                      <th class="text-center">خریدار</th>
                      <th class="text-center">زمان‌صدور</th>
                      <th class="text-center">وضعیت‌پرداخت</th>
                      <th class="text-center">نوع پرداخت</th>
                      <th class="text-center">مبلغ‌کل(ریال)</th>
                      <th class="text-center">وضعیت رسیدگی</th>
                      <th class="text-center">وضعیت حذف</th>
                      <th class="text-center">عملیات</th>
                    </tr>
                    </thead>
                    <tfoot>
                    <tr>
                      <th class="text-center">فاکتور</th>
                      <th class="text-center">شماره‌فاکتور</th>
                      <th class="text-center">فروشگاه</th>
                      <th class="text-center">فروشنده</th>
                      <th class="text-center">کالاها</th>
                      <th class="text-center">خریدار</th>
                      <th class="text-center">زمان‌صدور</th>
                      <th class="text-center">وضعیت‌پرداخت</th>
                      <th class="text-center">نوع پرداخت</th>
                      <th class="text-center">مبلغ‌کل(ریال)</th>
                      <th class="text-center">وضعیت رسیدگی</th>
                      <th class="text-center">وضعیت حذف</th>
                      <th class="text-center">عملیات</th>
                    </tr>
                    </tfoot>
                    <tbody class="text-center">
                    <tr v-for="item in factorsData.FactorList" :key="item._id">
                      <td class="p-1 align-middle">
                                                <span
                                                    :class="{'text-success':item.Factor.IsOnline,'text-danger':!item.Factor.IsOnline}">
                                                    {{ item.Factor.IsOnline === true ? "آنلاین" : "حضوری" }}
                                                </span>

                      </td>
                      <td class="p-1 align-middle">{{ item.FactorCode }}</td>
                      <td class="p-1 align-middle">
                                                <span v-if="item.Factor.IsOnline">
                                                    ---
                                                </span>
                        <span v-else-if="!item.Factor.IsOnline">
                                                    {{ item.Shop.Title }}
                                                </span>

                      </td>
                      <td class="p-1 align-middle">
                        <a v-if="item.Factor.IsOnline" href="#">
                          ---
                        </a>
                        <a v-else-if="!item.Factor.IsOnline" href="#" @click="openSellerInfoModal(item)">
                          {{ `${item.Users.FirstName} ${item.Users.LastName}` }}
                        </a>
                      </td>
                      <td class="p-1 align-middle">
                        <a v-if="item.Factor.IsOnline" href="#"
                           @click="getFactorProducts(item._id)">مشاهده</a>
                      </td>
                      <td class="p-1 align-middle">
                        <a href="#" v-if="item.Customer" @click="openCustomerInfoModal(item)">
                          {{ `${item.Customer.FirstName} ${item.Customer.LastName}` }}
                        </a>

                      </td>
                      <td
                          class="p-1 align-middle"
                      >{{ item.CreatedAt | moment("HH:mm-jYYYY/jM/jD") }}
                      </td>
                      <td class="p-1 align-middle">
                        <span v-if="item.Factor.IsPayment===true" class="text-success">
                            پرداخت شد
                        </span>
                        <span v-else-if="!item.Factor.IsPayment===false" class="text-danger">
                            پرداخت نشده
                        </span>
                      </td>
                      <td class="p-1 align-middle">
                         <span v-if="item.PaymentType===2" class="text-success">
                                کیف پول
                         </span>
                        <span v-else-if="item.PaymentType===1" class="text-danger">
                            اعتباری
                        </span>

                      </td>

                      <td class="p-1 align-middle">
                                                <span v-if="item.Factor.IsOnline===true">
                                                    {{ splitDigit(totalFactor(item.Products)) }}
                                                </span>
                        <span v-else-if="item.Factor.IsOnline===false">
                                                    {{ splitDigit(item.Amount) }}
                                                </span>

                      </td>
                      <td class="p-1 align-middle">
                        <!--<i class='zmdi zmdi-close align-middle text-danger'
                           v-show="item.IsDeleted"></i>
                        <i class='zmdi zmdi-check align-middle text-success'
                           v-show="!item.IsDeleted"></i>-->
                        <span v-if="item.Factor.IsOnline">
                                                    {{ item.HandledStatusMessage }}
                                                </span>

                      </td>
                      <td class="p-1 align-middle">
                        <i class='zmdi zmdi-check align-middle text-danger'
                           v-show="item.IsDeleted"></i>
                      </td>
                      <td class="p-1">
                        <div v-if="item.Factor.IsOnline===true">
                          <a
                              href="#"
                              class="m-1 btn btn-primary btn-sm"
                              title="مشاهده جزئیات"
                              @click="getFactorAddress(item.Customer,item.AddressId)"
                          >
                            <i class="zmdi zmdi-my-location align-middle text-white"></i>
                          </a>
                          <a
                              href="#"
                              class="m-1 btn btn-warning btn-sm"
                              title="پرداخت فاکتور"
                              @click="openPaymentModal(item._id)">
                            <i class="zmdi zmdi-money align-middle text-white"></i>
                          </a>
                          <a
                              href="#"
                              class="m-1 btn btn-success btn-sm"
                              title="تغییر وضعیت فاکتور"
                              @click="openHandlingOrderModal(item._id)">
                            <i class="zmdi zmdi-settings align-middle text-white"></i>
                          </a>

                        </div>
                        <a
                            href="#"
                            class="m-1 btn btn-danger btn-sm"
                            title="حذف فاکتور"
                            @click="deleteFactor(item._id)" v-if="!item.IsDeleted">
                          <i class="zmdi zmdi-delete align-middle text-white"></i>
                        </a>

                        <a
                            href="#"
                            class="m-1 btn btn-danger btn-sm"
                            title="ویرایش فاکتور"
                            @click="openEditFactorModal(item._id)" v-if="!item.IsDeleted">
                          <i class="zmdi zmdi-edit align-middle text-white"></i>
                        </a>


                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <paginate
                :page-count="pageList"

                :prev-text="'قبلی'"
                :next-text="'بعدی'" :page-range="pageSize"
                :container-class="'custom-pagination'">
            </paginate>
            <!--<ul
                class="pagination pagination-warning d-flex flex-row justify-content-center align-items-center"
            >
              <li
                  class="page-item"
                  v-for="item in pageList"
                  :key="item"
                  :class="{ 'active': pageIndex === item }"
              >
                <a class="page-link" href="#" @click="getFactors(item,pageSize)">{{ item }}</a>
              </li>
            </ul>-->
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="div_ExcelReportModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title" id="defaultModalLabel">گزارش گیری</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form @submit.prevent="reportFactors()">
                  <div class="row m-0">
                    <!--<div class="col-md-12">
                        <label class="text-muted">پیش فاکتور</label>
                        <div class="form-group">
                            <div class="checkbox">
                                <input
                                        id="chb_PreFactor"
                                        type="checkbox"
                                        v-model="reportParams.PreFactor"
                                />
                                <label
                                        for="chb_PreFactor"
                                >{{reportParams.PreFactor==true?"نمایش":"مخفی"}}</label>
                            </div>
                        </div>
                    </div>-->
                    <fieldset class="border p-2" style="width: 100%;">
                      <legend class="w-auto">نوع فروش</legend>
                      <div class="col-md-12">
                        <div class="form-group">
                          <div class="checkbox">
                            <input
                                id="chb_SellingType_Attendance"
                                type="checkbox"
                                v-model="reportParams.SellingType_Attendance"
                            />
                            <label class="text-muted" for="chb_SellingType_Attendance">حضوری</label>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <div class="checkbox">
                            <input
                                id="chb_SellingType_Online"
                                type="checkbox"
                                v-model="reportParams.SellingType_Online"
                            />
                            <label for="chb_SellingType_Online" class="text-muted">آنلاین</label>
                          </div>
                        </div>
                      </div>
                    </fieldset>


                    <fieldset class="border p-2" style="width: 100%;">
                      <legend class="w-auto">نوع پرداخت</legend>
                      <div class="col-md-12">
                        <select class="form-control" v-model="reportParams.PaymentType">
                          <option value="2">کیف پول</option>
                          <option value="1">اعتباری</option>
                        </select>
                      </div>
                    </fieldset>


                    <fieldset class="border p-2" style="width: 100%;">
                      <legend class="w-auto">نوع فاکتور</legend>
                      <div class="col-md-12">
                        <div class="form-group">
                          <div class="checkbox">
                            <input
                                id="chb_FactorType_SellerFactors"
                                type="checkbox"
                                v-model="reportParams.FactorType_SellerFactors"
                            />
                            <label for="chb_FactorType_SellerFactors" class="text-muted">فروش</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <div class="checkbox">
                            <input
                                id="chb_FactorType_ReturnFactors"
                                type="checkbox"
                                v-model="reportParams.FactorType_ReturnFactors"
                            />
                            <label for="chb_FactorType_ReturnFactors" class="text-muted">برگشتی</label>
                          </div>
                        </div>
                      </div>
                    </fieldset>


                    <!--                    <div class="col-md-12">
                                          <label class="text-muted">فروش</label>
                                          <div class="form-group">
                                            <div class="checkbox">
                                              <input
                                                  id="chb_SellerFactors"
                                                  type="checkbox"
                                                  v-model="reportParams.SellerFactors"
                                              />
                                              <label
                                                  for="chb_SellerFactors">{{ reportParams.SellerFactors === true ? "نمایش" : "مخفی" }}</label>
                                            </div>
                                          </div>
                                        </div>-->
                    <!--                    <div class="col-md-12">
                                          <label class="text-muted">برگشت</label>
                                          <div class="form-group">
                                            <div class="checkbox">
                                              <input
                                                  id="chb_ReturnFactors"
                                                  type="checkbox"
                                                  v-model="reportParams.ReturnFactors"
                                              />
                                              <label
                                                  for="chb_ReturnFactors"
                                              >{{ reportParams.ReturnFactors === true ? "نمایش" : "مخفی" }}</label>
                                            </div>
                                          </div>
                                        </div>-->
                    <fieldset class="border p-2" style="width: 100%;">
                      <legend class="w-auto">فروشنده و خریدار</legend>
                      <div class="col-md-12">
                        <label>فروشنده</label>
                        <div class="form-group">
                          <v-select taggable
                                    :getOptionLabel="option =>option.Title"
                                    :options="sellerList" v-model="reportParams.SellerSelected"

                          >
                            <template slot="option" slot-scope="option">
                              <span class="fa"></span>
                              {{
                                `${option.Title}`
                              }}
                            </template>
                          </v-select>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <label>خریدار</label>
                        <div class="form-group">
                          <v-select taggable
                                    :getOptionLabel="option => option.FirstName+' '+option.LastName+'('+option.CardNumber+')'"
                                    :options="customerList"
                                    v-model="reportParams.CustomerSelected"
                                    >
                            <template slot="option" slot-scope="option">
                              <span class="fa"></span>
                              {{
                                `${option.FirstName} ${option.LastName}
                                                        (${option.CardNumber})`
                              }}
                            </template>
                          </v-select>
                        </div>
                      </div>

                    </fieldset>


                    <!--<div class="col-md-12">
                        <label>شماره‌همراه‌فروشنده</label>
                        <div class="form-group">
                            <input type="text" id="txt_SellerMobile" @input="checkParams($event)"
                                   class="form-control text-left"
                                   v-model="reportParams.SellerMobile"/>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <label>شماره‌همراه‌خریدار</label>
                        <div class="form-group">
                            <input type="text" id="txt_CustomerMobile" @input="checkParams($event)"
                                   class="form-control text-left"
                                   v-model="reportParams.CustomerMobile"/>
                        </div>
                    </div>-->


                    <fieldset class="border p-2" style="width: 100%;">
                      <legend class="w-auto">بازه زمانی</legend>
                      <div class="col-md-12">
                        <label>ازتاریخ</label>
                        <div class="form-group">
                          <date-picker
                              type="date"
                              :autoSubmit="true"
                              format="YYYY-MM-DD"
                              display-format="jYYYY-jMM-jDD"
                              v-model="reportParams.FromDate"
                          ></date-picker>
                        </div>

                      </div>

                      <div class="col-md-12">
                        <label>تاتاریخ</label>
                        <div class="form-group">
                          <date-picker
                              type="date"
                              :autoSubmit="true"
                              format="YYYY-MM-DD"
                              display-format="jYYYY-jMM-jDD"
                              v-model="reportParams.ToDate"
                          ></date-picker>
                        </div>
                      </div>


                    </fieldset>


                    <!--<div class="col-md-12">
                      <label class="text-muted">وضعیت خبر</label>
                      <div class="form-group">
                        <div class="checkbox">
                          <input id="chb_NewNewsStatus" type="checkbox" />
                          <label for="chb_NewNewsStatus">تست</label>
                        </div>
                      </div>
                    </div>-->

                  </div>

                  <div class="row m-0"></div>

                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >گزارش بده
                  </button>
                </form>
                <!--                {{reportParams}}-->
              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="div_NewFactorModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">فاکتور جدید</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form @submit.prevent="addFactor()">
                  <div class="row m-0">
                    <fieldset class="border p-2" style="width: 100%;">
                      <legend class="w-auto">فاکتور جدید</legend>
                      <div class="col-md-12">
                        <label>فروشنده</label>
                        <div class="form-group">
                          <v-select taggable
                                    :getOptionLabel="option =>option.Title"
                                    :options="sellerList" v-model="newFactor.SellerId"

                          >
                            <template slot="option" slot-scope="option">
                              <span class="fa"></span>
                              {{
                                `${option.Title}`
                              }}
                            </template>
                          </v-select>
                        </div>
                      </div>


                      <div class="col-md-12">
                        <label>خریدار</label>
                        <div class="form-group">
                          <v-select taggable
                                    :getOptionLabel="option => option.FirstName+' '+option.LastName+'('+option.CardNumber+')'"
                                    :options="customerList"
                                    v-model="newFactor.CustomerId"
                          >
                            <template slot="option" slot-scope="option">
                              <span class="fa"></span>
                              {{
                                `${option.FirstName} ${option.LastName}
                                                        (${option.CardNumber})`
                              }}
                            </template>
                          </v-select>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <label>مبلغ</label>
                        <div class="form-group">
                          <input
                              type="text"
                              class="form-control text-left"
                              v-model="newFactor.Amount" @input="splitAmountDigit($event.target.value)"
                          />
                        </div>
                      </div>


                      <div class="col-md-12">
                        <label>نوع تراکنش</label>
                        <div class="form-group">
                          <select class="form-control" v-model="newFactor.PaymentType">
                            <option value="2">کیف پول</option>
                            <option value="1">کارت اعتباری</option>
                          </select>
                        </div>
                      </div>


                      <div class="col-md-12">
                        <label>تاریخ تراکنش</label>
                        <div class="form-group">
                          <date-picker
                              type="datetime"
                              :autoSubmit="true"
                              format="YYYY-MM-DD HH:mm:ss"
                              display-format="jDD jMMMM jYYYY HH:mm"
                              v-model="newFactor.FactorDate"
                          ></date-picker>
                        </div>
                      </div>
                    </fieldset>

                  </div>

                  <div class="row">


                  </div>

                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >ثبت کن
                  </button>
                </form>
                <!--                {{reportParams}}-->
              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="div_OrderProductsModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
                        <span class="title" v-if="factor.Customer">فاکتور
                        {{ `${factor.Customer.FirstName} ${factor.Customer.LastName}` }}
                        </span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">

            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>

                <div class="row m-0">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <table class="table table-bordered table-striped table-hover dataTable js-exportable">
                        <thead>
                        <tr>
                          <th class="text-center">ردیف</th>
                          <th class="text-center">کالا</th>
                          <th class="text-center">تعداد</th>
                          <th class="text-center">قیمت واحد(ریال)</th>
                          <th class="text-center">قیمت کل(ریال)</th>
                          <th class="text-center">فروشگاه</th>
                          <th class="text-center">وضعیت</th>
                          <th class="text-center">وضعیت رسیدگی</th>
                        </tr>
                        </thead>
                        <tbody class="text-center">
                        <tr v-for="(item, index) in factor.Products" :key="item._id">
                          <td class="p-1 align-middle">
                            {{ index + 1 }}
                          </td>
                          <td class="p-1 align-middle">
                            {{ item.ProductName }}
                          </td>
                          <td class="p-1 align-middle">
                            {{ item.Quantity }}
                          </td>
                          <td class="p-1 align-middle">
                            {{ splitDigit(item.UnitPrice) }}
                          </td>
                          <td class="p-1 align-middle">
                            {{ splitDigit(item.UnitPrice * item.Quantity) }}
                          </td>
                          <td class="p-1 align-middle">
                            {{ item.ShopId.Title }}
                          </td>

                          <td class="p-1">
                            {{ retProductStatus(item.Status) }}
                            <!-- <i class='zmdi zmdi-close align-middle text-danger'
                                v-show="item.IsDeleted"></i>
                             <i class='zmdi zmdi-check align-middle text-success'
                                v-show="!item.IsDeleted"></i>-->
                          </td>
                          <td class="p-1 align-middle"
                              v-html="retFactorStatus(item.ShopId._id)">
                          </td>
                        </tr>
                        <tr>
                          <td class="p-1 align-middle bg-info text-light" colspan="8"
                              v-if="factor.Products">
                            مبلغ قابل پرداخت فاکتور:
                            {{ splitDigit(totalFactor(factor.Products)) }}
                            ریال
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="row m-0"></div>

              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="div_OrderAddressModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
                        <span class="title" v-if="factor.Customer">آدرس دریافت سفارش
                        {{ `${factor.Customer.FirstName} ${factor.Customer.LastName}` }}
                        </span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <h6>
                آدرس انتخابی مشتری جهت تحویل سفارش
              </h6>
              <div v-html="customerAddress">
              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="div_PaymentModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
                        <span class="title" v-if="factor.Customer">
                            پرداخت سفارش
                        </span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <!-- <h6>
                   آدرس انتخابی مشتری جهت تحویل سفارش
               </h6>
               <div v-html="customerAddress">
               </div>-->
              <div class="alert alert-warning text-center" role="alert" v-if="factor.Customer">
                موجودی فعلی مشتری
                {{ splitDigit(factor.Customer.Cash) }} ریال
              </div>
              <div class="alert alert-warning text-center" v-if="factor.Products">
                مبلغ قابل پرداخت فاکتور:
                {{ splitDigit(totalFactor(factor.Products)) }}
                ریال
              </div>
              <div class="alert alert-danger text-center">
                همکار گرامی لطفاً توجه داشته باشید با فشردن دکمه زیر مبلغ فاکتور از موجودی کاربر کسر
                میگردد،بنابراین ابتدا بررسی نمایید که فروشنده کالاهای مشتری را تغییر وضعیت داده باشد
              </div>
              <form @submit.prevent="paymentFactor()">
                <button
                    type="submit"
                    class="btn btn-raised btn-success btn-block waves-effect"
                >
                  تایید نهایی(ارسال فاکتور قطعی)
                </button>
              </form>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="div_HandlingOrderModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
                        <span class="title">
                            تغییر وضعیت سفارش
                        </span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <!-- <h6>
                   آدرس انتخابی مشتری جهت تحویل سفارش
               </h6>
               <div v-html="customerAddress">
               </div>-->

              <form @submit.prevent="changeOrderStatus()">
                <select class="form-control" v-model="factor.HandledStatus">
                  <option value="1">
                    در انتظار رسیدگی
                  </option>
                  <option value="2">
                    در دست رسیدگی
                  </option>
                  <option value="3">
                    ارسال کلیه کالاها
                  </option>
                  <option value="4">
                    عدم موجودی کالاها
                  </option>
                  <option value="5">
                    انصراف از ارسال کالاها
                  </option>
                  <option value="6">
                    ارسال کالاهای موجود
                  </option>
                  <option value="7">
                    اعتبار شما کافی نمی‌باشد
                  </option>
                </select>
                <button
                    type="submit"
                    class="btn btn-raised btn-success btn-block waves-effect"
                >
                  تغییر بده
                </button>
              </form>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="div_SellerInfoModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
                        <span class="title">اطلاعات فروشنده

                        </span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div v-html="sellerInfo">
              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="div_CustomerInfoModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
                        <span class="title">اطلاعات خریدار
                        </span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div v-html="customerInfo">
              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="div_EditFactorModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
                        <span class="title">ویرایش فاکتور
                        </span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form @submit.prevent="editAmountFactor()">
                  <div class="row">
                    <div class="col-md-12">
                      <label>مبلغ فعلی فاکتور(ریال)</label>
                      <div class="form-group">
                        <input
                            type="text"
                            class="form-control text-left"
                            v-model="factor.Amount" @input="splitAmountDigit($event.target.value)" disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <label>مبلغ جدید فاکتور(ریال)</label>
                      <div class="form-group">
                        <input
                            type="text"
                            class="form-control text-left"
                            v-model="factor.EditAmount" @input="splitEditAmountDigit($event.target.value)"
                        />
                      </div>
                    </div>
                  </div>


                  <!--                  <div class="row">
                                      <div class="col-md-12">
                                        <label>توضیحات</label>
                                        <div class="form-group">
                                          <textarea rows="4" cols="50" class="form-control text-right"
                                                    v-model="factor.LogDesc" style="text-align: right !important;">
                                            </textarea>
                                        </div>
                                      </div>
                                    </div>-->

                  <div class="row">

                  </div>
                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >ثبت کن
                  </button>
                </form>
              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="div_MakeReportModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">گزارش جدید</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form @submit.prevent="makeReport">
                  <fieldset class="border p-2" style="width: 100%;">
                    <legend class="w-auto">بازه زمانی</legend>
                    <div class="row">
                      <div class="col-md-6">
                        <label>از تاریخ</label>
                        <div class="form-group">
                          <date-picker
                              type="date"
                              :autoSubmit="true"
                              format="YYYY-MM-DD"
                              display-format="jYYYY-jMM-jDD"
                              v-model="reportParams.FromDate"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label>تا تاریخ</label>
                        <div class="form-group">
                          <date-picker
                              type="date"
                              :autoSubmit="true"
                              format="YYYY-MM-DD"
                              display-format="jYYYY-jMM-jDD"
                              v-model="reportParams.ToDate"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </fieldset>


                  <fieldset class="border p-2" style="width: 100%;">
                    <legend class="w-auto">طرف ها</legend>
                    <div class="row">
                      <div class="col-md-6">
                        <label>فروشندگان</label>
                        <div class="form-group">
                          <v-select taggable
                                    :getOptionLabel="option =>option.Title"
                                    :options="sellerList" v-model="reportParams.SellerSelected"

                          >
                            <template slot="option" slot-scope="option">
                              <span class="fa"></span>
                              {{
                                `${option.Title}`
                              }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label>مشتریان</label>
                        <div class="form-group">
                          <v-select
                              :getOptionLabel="option => option.Title"
                              :options="organizationCategory" v-model="reportParams.CustomerSelected"
                          >
                            <template slot="option" slot-scope="option">
                              <span class="fa">{{ `${option.Title}` }}</span>
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </fieldset>


                  <fieldset class="border p-2" style="width: 100%;">
                    <legend class="w-auto">فیلترها</legend>
                    <div class="row">
                      <div class="col-md-6">
                        <!--                        <label>فروشندگان</label>-->
                        <div class="form-group">
                          <div class="checkbox">
                            <input
                                id="chb_PreFactor"
                                type="checkbox"
                            />
                            <label
                                for="chb_PreFactor"
                            >فروش ها</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label>مشتریان</label>
                        <div class="form-group">

                        </div>
                      </div>
                    </div>
                  </fieldset>


                  <!--<div class="row m-0">
                  <div class="col-md-12">
                    <label>از تاریخ</label>
                    <div class="form-group">
                      <date-picker
                          type="date"
                          :autoSubmit="true"
                          format="YYYY-MM-DD"
                          display-format="jYYYY-jMM-jDD"
                          v-model="rahkaranReportParams.TargetDate"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label>تا تاریخ</label>
                    <div class="form-group">
                      <date-picker
                          type="date"
                          :autoSubmit="true"
                          format="YYYY-MM-DD"
                          display-format="jYYYY-jMM-jDD"
                          v-model="rahkaranReportParams.TargetDate"
                      ></date-picker>
                    </div>
                  </div>
                </div>-->
                  <div class="row m-0"></div>
                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >گزارش بده
                  </button>
                </form>
                <!--                {{reportParams}}-->
              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Paginate from 'vuejs-paginate';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  data() {
    return {
      /*newsFields: { Title: "", Content: "", Status: false },
      editNewsFields: { Title: "", Content: "", Status: false, _id: "" },*/
      loadingShow: false,
      pageSize: 10,
      pageList: 0,
      pageIndex: undefined,
      factorsData: {FactorList: [], FactorCount: 0},
      reportParams: {
        FromDate: null,
        ToDate: null,
        // SellerMobile: "",
        // CustomerMobile: "",
        // PreFactor: false,
        FactorType_SellerFactors: false,
        FactorType_ReturnFactors: false,
        CustomerSelected: null,
        SellerSelected: null,
        SellingType_Attendance: false,
        SellingType_Online: false,
        PaymentType: 1
      },
      reportFileName: "",
      sellerList: [],
      customerList: [],
      factor: {
        EditAmount: 0,
        // LogDesc:""
      },
      customerAddress: "",
      newFactor: {
        Amount: undefined,
        SellerId: undefined,
        CustomerId: undefined,
        FactorDate: undefined,
        PaymentType: undefined
      },
      customerInfo: "",
      sellerInfo: "",
      rahkaranReportParams: {TargetDate: null},


      organizationCategory: []
    };
  },
  methods: {
    getOrganizationCategory() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = false;
      axios
          .get(`/Panel/V2/Users/GetOrganizationCategory`, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            console.log(res.data);
            if (res.data.Status === 1) {

              self.organizationCategory = res.data.Data.OrganizationCategory;
              /*self.organizationCategory.push({
                Code: "0000",
                Title: "همه"
              })*/
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: res.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
            //console.log(error);
          })
          .finally(function (params) {
            self.loadingShow = false;
          });
    },


    openMakeReportModal() {
      let self = this;
      $("#div_MakeReportModal").modal("show");
    },
    /*makerReportRahkaran(){
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .post(`/API/Panel/V1/Installments/MakeInstallmentReport`, {
            TargetDay:self.rahkaranReportParams.TargetDate
          }, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            // console.log(response.data);
            if (response.data.Status === 1) {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "success",
                duration: 5000
              });
              window.open(response.data.Data);
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },*/
    /*openEditFactorModal(id) {
      let self = this;
      self.getFactorById(id);
      $("#div_EditFactorModal").modal("show");
    },*/
    /*editAmountFactor() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .post(`/api/panel/Factor/v1/EditAmountFactor`, {
            NewAmount: parseInt(self.factor.EditAmount.replace(/,/g, '')),
            _id: self.factor._id
          }, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            if (response.data.Status === 1) {
              self.getFactors();
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },*/
    /* deleteFactor(id) {
       let self = this;
       if (confirm("آیا از حذف این فاکتور اطمینان دارید؟") === true) {
         let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
         self.loadingShow = true;
         this.axios
             .post("/api/panel/Factor/v1/DeleteFactor", {_id: id}, {
               headers: {
                 authorization: userInfo.Token
               }
             })
             .then(function (res) {
               console.log("testtt", res);
               if (res.data.Status === 1) {
                 self.$toast.open({
                   position: "bottom-right",
                   message: res.data.Message,
                   type: "success",
                   duration: 5000
                 });
                 self.getFactors(self.pageIndex)
               } else {
                 self.$toast.open({
                   position: "bottom-right",
                   message: res.data.Message,
                   type: "error",
                   duration: 5000
                 });
               }
             })
             .catch(function () {
               self.$toast.open({
                 position: "bottom-right",
                 message: "خطای نامعلومی رخ داده است",
                 type: "error",
                 duration: 5000
               });
             })
             .finally(function () {
               self.loadingShow = false;
             });
       }
     },*/
    /*openSellerInfoModal(factor) {
      let self = this;
      if (factor !== undefined && factor !== null) {
        self.sellerInfo = `
                    <p>نام: ${factor.Users.FirstName}</p>
                    <p>نام خانوادگی: ${factor.Users.LastName}</p>
                    <p>شماره همراه: ${factor.Users.Mobile}</p>
                    <p>موجودی اعتباری: ${self.splitDigit(factor.Users.Cash)} ریال</p>
                    `;
      }
      $("#div_SellerInfoModal").modal("show");
    },*/
    /*openCustomerInfoModal(factor) {
      let self = this;
      // console.log(factor)
      if (factor !== undefined && factor !== null) {
        self.customerInfo = `
                    <p>نام: ${factor.Customer.FirstName}</p>
                    <p>نام خانوادگی: ${factor.Customer.LastName}</p>
                    <p>شماره همراه: ${factor.Customer.Mobile}</p>
                    <p>موجودی اعتباری: ${self.splitDigit(factor.Customer.Cash)} ریال</p>
                    `;
      }
      $("#div_CustomerInfoModal").modal("show");
    },*/
    /*splitEditAmountDigit(val) {
      const self = this;
      const result = val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      self.$nextTick(() => {
        self.factor.EditAmount = result;
      });
    },*/
    /*splitAmountDigit(val) {
      const self = this;
      const result = val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      self.$nextTick(() => {
        self.newFactor.Amount = result;
      });
    },*/
    makeReport() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .post(`/Panel/V2/Factors/MakeReportManager`, {
            From: self.reportParams.FromDate,
            To: self.reportParams.ToDate,
            Seller:self.reportParams.SellerSelected,
            Customer:self.reportParams.CustomerSelected
          }, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            // console.log(response.data);
            if (response.data.Status === 1) {
              // self.getFactors();
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    postSanad() {
      let self = this;
      // let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      // self.loadingShow = true;
      axios
          .post(`http://192.168.1.58/sg3g/x4aa9dd67/Financial/VoucherManagement/Services/VoucherService.svc/RegisterVoucher`, {
            "BranchRef": 1,
            "LedgerRef": 1,
            "VoucherTypeRef": 1,
            "Date": new Date(),
            "Description": "این یک تست میباشد و صرفاً تست میباشد",
            "VoucherItems ": [
              {
                "SLCode": "11201",
                "RowNumber": 1,
                "Description": "این یک تست میباشد و صرفاً یک تست میباشد",
                "DL4": "060001001",
                "DL5": "808400000",
                "DL6": "808400502",
                "Debit": 20000
              }
            ]
          }, {
            headers: {
              "sg-auth-sg": "d79f8240-c0c2-403c-b19d-4adeadbc3730"
            }
          })
          .then(function (response) {
            console.log(response.data);

          })
          .catch(function (error) {
          })
          .finally(function () {
            // self.loadingShow = false;
          });
    },
    /*retProductStatus(status) {
      switch (status) {
        case 1:
          return "منتظر رسیدگی فروشگاه";
        case 2:
          return "عدم موجودی";
        case 3:
          return "ارسال میشود";
      }
    },*/
    /*totalFactor(products) {
      let sum = products.filter(({Status}) => Status === 3).reduce(function (accumulator, item) {
        return accumulator + (item.UnitPrice * item.Quantity);
      }, 0);

      return sum;
    },*/
    /*getFactorProducts(factorId) {
      let self = this;
      self.getFactorById(factorId);
      $("#div_OrderProductsModal").modal("show");
    },*/
    /*openPaymentModal(factorId) {
      let self = this;
      self.getFactorById(factorId);
      $("#div_PaymentModal").modal("show");
    },*/
    /*openNewFactorModal() {
      let self = this;
      // self.getFactorById(factorId);
      self.getSellerList();
      self.getCustomerList();
      $("#div_NewFactorModal").modal("show");
    },*/
    /*openHandlingOrderModal(factorId) {
      let self = this;
      self.getFactorById(factorId);
      $("#div_HandlingOrderModal").modal("show");
    },*/
    /*getFactorAddress(customer, addressId) {
      let self = this;
      let customerAddress = customer.AddressesList.find(item => {
        return item._id == addressId
      });
      if (customerAddress != undefined) {
        self.customerAddress = `
                    <p>استان: ${customerAddress.Province}</p>
                    <p>شهر: ${customerAddress.City}</p>
                    <p>خیابان: ${customerAddress.Street}</p>
                    <p>کدپستی: ${customerAddress.PostalCode}</p>
                    <p>تلفن تماس: ${customerAddress.Cellphone}</p>
                    <p>پلاک:${customerAddress.Plaque}</p>
                    <p>طبقه:${customerAddress.Floor}</p>
                    <p>واحد:${customerAddress.Unit}</p>
                    `;
      }
      $("#div_OrderAddressModal").modal("show");
    },*/
    /*retFactorStatus(shopId) {
      let self = this;
      let status = self.factor.ShopHandled.find(function (item) {
        return item.ShopId._id == shopId;
      });
      if (status != undefined) {
        return `<span class="text-success">رسیدگی کرده</span>`;
      } else {
        return `<span class="text-danger">رسیدگی نکرده</span>`;
      }
    },*/
    /*openReportModal() {
      $('#div_ExcelReportModal').modal('show');
      this.getSellerList();
      this.getCustomerList();
    },*/
    getSellerList() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get("/GetShopList", {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            console.log("kkkk", response.data);
            // console.log(response.data);
            self.sellerList = response.data.Data.ShopList;
            /*self.sellerList.push({
              _id: "0",
              Title: "همه"
            })*/
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    /*getCustomerList() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get("/GetCustomerList", {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(async function (response) {
            self.customerList = await response.data.Data.CustomerList;
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },*/
    /*getFactors(pageIndex = 1, limit = 10) {
      let self = this;
      limit = self.pageSize;
      self.pageIndex = pageIndex;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get("/api/panel/Factor/v1/GetFactors", {
            params: {
              PageIndex: pageIndex,
              Limit: limit
            },
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            console.log("GetFactors", response.data);
            self.factorsData.FactorList = response.data.Data.FactorList;
            self.factorsData.FactorCount = response.data.Data.FactorCount;
            let pageCount = self.factorsData.FactorCount % self.pageSize === 0 ? self.factorsData.FactorCount / self.pageSize : self.factorsData.FactorCount / self.pageSize + 1;
            self.pageList = Math.floor(pageCount);
          })
          .catch(function () {
            self.loadingShow = false;
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },*/
    /*splitDigit(val) {
      val += '';
      val = val.replace(',', '');
      let x = val.split('.');
      let y = x[0];
      let z = x.length > 1 ? '.' + x[1] : '';
      let rgx = /(\d+)(\d{3})/;
      while (rgx.test(y))
        y = y.replace(rgx, '$1' + ',' + '$2');
      return y + z;
    },*/
    /*getFactorById(id) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get(`/api/panel/Factor/v1/GetFactorById`, {
            params: {FactorId: id},
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            console.log(response.data);

            if (response.data.Status == 1) {
              self.factor = response.data.Data.Factor;
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
          })
          .finally(function (params) {
            self.loadingShow = false;
          });
    },*/
    /*paymentFactor() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      let formData = {
        FactorId: self.factor._id
      };
      self.loadingShow = true;
      axios
          .post(`/api/panel/Factor/v1/PaymentFactor`, formData, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            // console.log(response.data);
            if (response.data.Status === 1) {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },*/
    /*changeOrderStatus() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      let formData = {
        FactorId: self.factor._id,
        HandledStatus: self.factor.HandledStatus
      };
      self.loadingShow = true;
      axios
          .post(`/api/panel/Factor/v1/ChangeOrderStatus`, formData, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            console.log(response.data);
            if (response.data.Status == 1) {
              self.getFactors();
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },*/
    /*removeFactor(id) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      this.axios
          .post("/RemoveFactor", {_id: id}, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            console.log("testtt", res);
            if (res.data.Status === 1) {
              self.getFactors(self.pageIndex)
            }
          })
          .catch(function () {
            self.$toast.open({
              position: "bottom-right",
              message: "خطای نامعلومی رخ داده است",
              type: "error",
              duration: 5000
            });
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },*/
    /*reportFactors() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      let ReportParams = self.reportParams;
      self.loadingShow = true;
      this.axios
          .post("/ReportFactors", {ReportParams: ReportParams}, {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(async function (response) {
            if (response.data.Status === 1) {
              self.reportFileName = await response.data.Data.Report;
              self.downloadReportFile()
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: response.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function () {
            self.$toast.open({
              position: "bottom-right",
              message: "خطای نامعلومی رخ داده است",
              type: "error",
              duration: 5000
            });
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },*/
    /*checkParams(type) {
      let self = this;
      switch (type) {
        case "customer":
          self.reportParams.SellerSelected = null;
          break;
        case "seller":
          self.reportParams.CustomerSelected = null;
          break;
      }
    },*/
    /*downloadReportFile() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post('/DownloadReportFile', {
            FileName: self.reportFileName
          },
          {
            responseType: 'blob',
          },
      ).then((response) => {
        const url = URL.createObjectURL(new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', self.reportFileName);
        document.body.appendChild(link);
        link.click()
      });
    }*/
  },
  computed: {
    // retCustomer: function () {
    //     return customer => customer === null ? "پیش فاکتور" : `${customer.FirstName} ${customer.LastName}(${customer.CardNumber})`;
    // },
    // paymentStatus: function () {
    //     return status => status === true ? "پرداخت شد" : "منتظرپرداخت"
    // }
  },

  created() {
    let self = this;
    // self.getFactors();
    self.getOrganizationCategory();
    self.getSellerList();
  },
  watch: {
    pageSize: function (val) {
      // this.getFactors(this.pageIndex, this.pageSize);
    }
  },
  components: {
    simplebar,
    datePicker: VuePersianDatetimePicker,
    'v-select': vSelect,
    'paginate': Paginate
  }

};
</script>

<style>
.custom-pagination {
  list-style: none;
}

.custom-pagination li {
  list-style: none;
  margin: 0px 10px;
  display: inline;
}

.custom-pagination li a {
  color: #45494a;
}

.custom-pagination li.active {
  background-color: #FF9948;
  border-color: #FF9948;
  font-size: 14px;
  border-radius: 30px !important;
  padding: 3px 11px;
  margin: 0 3px;
  min-width: 30px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  text-transform: uppercase;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
  color: #fff;
}
</style>
